import Axios from 'axios';
import * as ActionTypes from './types';
import * as API from '../network/api';
import HHRequest, { HHAxiosRequest } from '../network';
import { hlog } from '../common/util';
import { handleResponseCode } from './index';

export const fetchEventDetail = (
  eventSlug,
  token,
  callback
) => async dispatch => {
  if (token) {
    try {
      const requestBody = { slug: eventSlug, token };
      const res = await HHRequest(API.FETCH_EVENT_DETAIL, requestBody);
      handleResponseCode(res.code);
      if (res.code === 200) {
        dispatch({
          type: ActionTypes.FETCH_EVENT_DETAIL,
          payload: { eventDetail: res.event },
        });
        if (callback) callback({ event: res.event });
      }
    } catch (err) {
      hlog(err);
    }
  } else {
    try {
      const requestBody = { slug: eventSlug };
      const res = await HHRequest(API.FETCH_EVENT_DETAIL, requestBody);

      handleResponseCode(res.code);
      if (res.code === 200) {
        dispatch({
          type: ActionTypes.FETCH_EVENT_DETAIL,
          payload: { eventDetail: res.event },
        });
        if (callback) callback({ event: res.event });
      }
    } catch (err) {
      hlog(err);
    }
  }
};

export const fetchEventTeams = (eventSlug, callback) => async dispatch => {
  try {
    const requestBody = { slug: eventSlug };
    const res = await HHRequest(API.FETCH_EVENT_TEAMS, requestBody);

    handleResponseCode(res.code);
    if (res.code === 200) {
      dispatch({
        type: ActionTypes.FETCH_EVENT_TEAMS,
        payload: { eventTeams: res.teams },
      });
      if (callback) callback({ eventTeams: res.teams });
    }
  } catch (err) {
    hlog(err);
  }
};

export const fetchTeamGroups = (
  eventSlug,
  token,
  callback
) => async dispatch => {
  try {
    const requestBody = { eventSlug, token };
    const res = await HHRequest(API.CMS_TEAM_GROUP_LIST, requestBody);

    handleResponseCode(res.code);
    if (res.code === 200) {
      dispatch({
        type: ActionTypes.FETCH_TEAM_GROUPS,
        payload: { teamGroups: res.groups },
      });
      if (callback) callback({ teamGroups: res.groups });
    }
  } catch (err) {
    hlog(err);
  }
};

export const fetchSignleEventTeam = (id, callback) => async (
  dispatch,
  getState
) => {
  try {
    const requestBody = { teamId: id, token: getState().user.token };
    const res = await HHRequest(API.FETCH_SINGLE_EVENT_TEAM, requestBody);

    handleResponseCode(res.code);
    if (res.code === 200) {
      dispatch({
        type: ActionTypes.FETCH_SINGLE_EVENT_TEAM,
        payload: { eventTeam: res.team },
      });
      if (callback) callback({ eventTeam: res.team });
    }
  } catch (err) {
    hlog(err);
  }
};

export const fetchUserTeam = (userId, eventSlug, callback) => async (
  dispatch,
  getState
) => {
  try {
    const requestBody = { userId, eventSlug, token: getState().user.token };
    const res = await HHRequest(API.FETCH_SINGLE_EVENT_TEAM, requestBody);

    if (res.code === 200) {
      dispatch({
        type: ActionTypes.FETCH_USER_TEAM,
        payload: { userTeam: res.team },
      });
      if (callback) callback({ userTeam: res.team });
    } else {
      dispatch({
        type: ActionTypes.FETCH_USER_TEAM,
        payload: { userTeam: {} },
      });
    }
  } catch (err) {
    hlog(err);
  }
};

export const fetchEventSubmissions = (
  slug,
  token,
  callback
) => async dispatch => {
  try {
    const requestBody = { slug, token };
    const res = await HHRequest(API.FETCH_EVENT_SUBMISSIONS, requestBody);

    handleResponseCode(res.code);
    if (res.code === 200) {
      dispatch({
        type: ActionTypes.FETCH_EVENT_SUBMISSIONS,
        payload: { eventSubmissions: res.submissions },
      });
      if (callback) callback({ eventSubmissions: res.submissions });
    }
  } catch (err) {
    hlog(err);
  }
};

export const fetchEventSubmissionsForJudge = async (slug, token) => {
  try {
    const requestBody = { eventSlug: slug, token };
    const res = await Axios.post(
      API.FETCH_EVENT_SUBMISSIONS_FOR_JUDGE,
      requestBody
    );
    const { code, response } = res.data;
    handleResponseCode(code);
    if (code === 200 && response.submissions) {
      return response.submissions;
    }
    return [];
  } catch (err) {
    hlog(err);
    return [];
  }
};

export const fetchEventSubmission = async (id, token) => {
  let submission = {};
  try {
    const requestBody = { id, token };
    const res = await Axios.post(API.FETCH_EVENT_SUBMISSION, requestBody);

    handleResponseCode(res.data.code);
    if (res.data.code === 200) {
      submission = res.data.submission;
      return submission;
    }
    return submission;
  } catch (err) {
    hlog(err);
    return {};
  }
};

export const fetchEventSubmissionForJudge = async (
  submissionId,
  token,
  eventSlug
) => {
  try {
    const payload = { submissionId, token, eventSlug };
    const res = await Axios.post(API.FETCH_EVENT_SUBMISSION_FOR_JUDGE, payload);

    const { response, code } = res.data;
    handleResponseCode(code);
    if (code === 200 && response) {
      return response;
    }
    return {};
  } catch (err) {
    return {};
  }
};

export const fetchEventLists = (index, countPerPage, token) => async dispatch =>
  new Promise(async (resolve, reject) => {
    try {
      const requestBody = { index, countPerPage, token };
      const res = await HHAxiosRequest(API.FETCH_EVENT_LISTS, requestBody);
      if (res && res.data) {
        const { code } = res.data;
        handleResponseCode(code);
        if (code === 200) {
          dispatch({
            type: ActionTypes.FETCH_EVENT_LISTS,
            payload: res.data.response.events,
          });
          resolve();
        }
      }
    } catch (err) {
      hlog(err);
      reject(err);
    }
  });

export const fetchMoreEventLists = (
  index,
  countPerPage,
  token
) => async dispatch =>
  new Promise(async (resolve, reject) => {
    try {
      const requestBody = { index, countPerPage, token };
      const res = await HHAxiosRequest(API.FETCH_EVENT_LISTS, requestBody);
      if (res && res.data) {
        const { code } = res.data;
        handleResponseCode(code);
        if (code === 200) {
          dispatch({
            type: ActionTypes.FETCH_MORE_EVENT_LISTS,
            payload: res.data.response.events,
          });
          resolve();
        }
      }
    } catch (err) {
      hlog(err);
      reject(err);
    }
  });

export const resetEventLists = () => async dispatch => {
  dispatch({
    type: ActionTypes.RESET_EVENT_LISTS,
    payload: '',
  });
};

export const fetchInitialEvents = token => async dispatch =>
  new Promise(async (resolve, reject) => {
    try {
      const requestBody = { token };
      const res = await HHAxiosRequest(API.FETCH_INITIAL_EVENTS, requestBody);
      if (res && res.data) {
        const { code } = res.data;
        handleResponseCode(code);
        if (code === 200) {
          dispatch({
            type: ActionTypes.FETCH_INITIAL_EVENTS,
            payload: res.data.response,
          });
          resolve();
        }
      }
    } catch (err) {
      hlog(err);
      reject(err);
    }
  });

export const resetInitialEvents = () => async dispatch => {
  dispatch({
    type: ActionTypes.RESET_INITIAL_EVENTS,
    payload: '',
  });
};



// WEBPACK FOOTER //
// ./src/components/actions/event.js